// TODO Fonts are here
export const CLASSIC_TYPO = 'Poppins Regular';
export const MEDIUM_TYPO = 'Poppins Medium';
export const BOLD_TYPO = 'Poppins Bold, Roboto';
export const ARRAY_TYPO = ['Poppins Regular', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'];

export const FONTSIZE_2XS = '0.625rem'; // 10px
export const FONTSIZE_XS = '0.75rem'; // 12px
export const FONTSIZE_S = '0.875rem'; // 14px
export const FONTSIZE_M = '1rem'; // 16px
export const FONTSIZE_L = '1.125rem'; // 18px
export const FONTSIZE_XL = '1.25rem'; // 20px
export const FONTSIZE_2XL = '1.5rem'; // 24px
export const FONTSIZE_3XL = '1.75rem'; // 28px
